<div class="search">
  <input type="text" class="form-control" [formControl]="input" [placeholder]="placeholder" />
  <div class="icon-container">
    <i class="material-icons mi-20">search</i>
  </div>
</div>
